export const ERR_DEFAULT_MSG = 'Something went wrong. Please try again later or contact with the team support.';
